<template>
  <div class="account-settings">
    <Header />
    <div class="settings-main">
      <div class="settings-navigation">
        <SettingsNavigation></SettingsNavigation>
      </div>
      <div class="email">
        <div class="email-main">
          <p class="indentation">
            आपका इमेल पता बदलना चाहते हैं? कोई समस्या नहीं. सिर्फ अपने नये
            प्रविष्ट करें पता और पासवर्ड नीचे और "ईमेल बदलें" बटन क्लिक करें.
          </p>
          <p>
            हम तुम्हारे लिए एक पुष्टिकरण इमेल भेजेंगे. जब वह पहुँचेगी, आपको भीतर
            लिंक क्लिक करना चाहिए कि पुष्टि करने के लिए यह सच्चे आप बनाते हैं यह
            अनुरोध. (बस थोड़ी सावधानी!)
          </p>
          <div class="wide">
            यदि हम तुम्हारी ओर से नहीं सुनेंगे, तो हम तुम्हारे लिए तुम्हारा खाता
            स्थगित करेंगे सुरक्षा.
          </div>
          <div class="info">मौजूदा इमेल पता</div>
          <div class="info">{{ userName }}</div>
          <div class="input-boxs">
            <div>नया इमेल पता</div>
            <input type="text" v-model="userName" class="disabled" disabled />
          </div>

          <div class="update">
            <div>ईमेल बदलें</div>
          </div>
        </div>
      </div>
      <div class="settings-avatarurl">
        <AvatarUrl></AvatarUrl>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import SettingsNavigation from "./mycom/settingsNavigation.vue";
import AvatarUrl from "./mycom/avatarUrl.vue";
import Account from "./mycom/account.vue";
export default {
  components: { Header, Footer, SettingsNavigation, AvatarUrl, Account },
  data() {
    return {
      checked: false,
      userName: "001****2345@qq.com",
    };
  },
  methods: {
    submit() {
      this.checked = true;
    },
  },
  created() {
    if (localStorage.getItem("accountInfo")) {
      this.userName = JSON.parse(localStorage.getItem("accountInfo")).userName;
    }
  },
};
</script>
<style scoped>
.account-settings {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.settings-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
  display: flex;
}
.email {
  width: 100%;
}
.email-main {
  width: 337.5px;
  margin-left: 40.625px;
}
.email-main > p {
  font-size: 10px;
  color: #232323;
  margin-bottom: 15px;
  line-height: 15px;
}
input {
  width: calc(100% - 11.25px);
  height: 28px;
  line-height: 28px;
  border-radius: 1.25px;
  border: 0.625px solid #dddddd;
  padding-left: 10px;
  font-size: 10px;
}
.input-boxs > div {
  font-size: 10px;
  margin-bottom: 7px;
  margin-top: 20px;
}
.explain {
  margin-top: 12.5px;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 12.5px;
}
.wide {
  font-weight: bold;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 22.5px;
}
.info {
  font-size: 10px;
  margin-bottom: 10px;
}
.update {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.update > div {
  width: 81.875px;
  height: 22.5px;
  border-radius: 1.5px;
  border: 0.625px solid #ddd;
  text-align: center;
  line-height: 22.5px;
  margin-top: 30px;
  font-size: 10px;
  cursor: pointer;
  color: #dcdbe2;
  background-color: #f5f7fa;
  cursor: no-drop;
}
.update-check > div {
  background-color: #2e67ea;
  color: #fff;
}
.indentation {
  text-indent: 2em;
}
.disabled {
  color: #dcdbe2;
  background-color: #f5f7fa;
  cursor: no-drop;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 1280px) {
  .settings-main {
    width: calc(100% - 95px);
    padding: 20px 47.5px;
  }
}
@media only screen and (max-width: 1100px) {
  .settings-avatarurl {
    display: none;
  }
}
@media only screen and (max-width: 900px) {
  .settings-main {
    width: calc(100% - 45px);
    padding: 20px 27.5px;
  }
  .email-main {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 800px) {
  .settings-main {
    width: calc(100% - 25px);
    padding: 20px 17.5px;
  }
  .email-main {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 768px) {
  .settings-navigation {
    display: none;
  }
  .settings-main {
    width: 100%;
    padding: 20px 0;
  }
  .email-main {
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/email.vue